<div translate translation="fillDeleteReason" class="h1-block-header dialog-header"></div>

<form [formGroup]="reasonForm">
  <div class="input-container">
    <div translate translation="reason" class="input-caption"></div>
    <input formControlName="reason" class="input-field" />
  </div>
</form>

<div class="dialog-button">
  <button [disabled]="!reasonForm.valid" (click)="onSaveClick()" mat-raised-button color="primary">
    <span translate translation="save"></span>
  </button>
</div>
